import React from 'react';
import { useIntl } from 'umi';
import { Icon } from 'tea-component';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import type { IStickyHeaderProps } from './types';
import './index.scss';

export const StickyHeader: React.FC<IStickyHeaderProps> = ({
  summaryItems = [],
  onClick,
  className,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div
      className={classnames('dbi-filterfixed-header', className)}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="dbi-filterfixed-header__body">
        <div className="dbi-filterfixed-header__summary">
          <div className="dbi-filterfixed-header__saved-filter">
            <Icon type="filter" className="dbi-filterfixed-header__saved-filter-icon" />
            <span className="dbi-filterfixed-header__saved-filter-text">
              {formatMessage({ id: 'dbi_filterSave_my_filter' })}
            </span>
          </div>
          {summaryItems.map(({ key, title, display, valueIconUrls = [], labelIcon }) => (
            <div className="dbi-filterfixed-header__summary-item" key={key}>
              <span className="dbi-filterfixed-header__summary-label">
                {labelIcon ? (
                  <SvgIcon
                    className={classnames(
                      'dbi-filterfixed-header__summary-label-icon',
                      labelIcon.className,
                    )}
                    type={labelIcon.type}
                  />
                ) : null}
                {title}
              </span>
              <span className="dbi-filterfixed-header__summary-value">
                {valueIconUrls.length > 0 ? (
                  <span className="dbi-filterfixed-header__summary-value-icons">
                    {valueIconUrls.map((iconSrc, index) => (
                      <img
                        key={`${key}-${iconSrc}-${index}`}
                        className="dbi-filterfixed-header__summary-value-icon"
                        src={iconSrc}
                        alt=""
                        aria-hidden
                      />
                    ))}
                  </span>
                ) : null}
                <span className="dbi-filterfixed-header__summary-value-text">{display}</span>
              </span>
            </div>
          ))}
        </div>
        <div className="dbi-filterfixed-header__show">
          <span>{formatMessage({ id: 'dbi_filter_show' })}</span>
          <SvgIcon
            type="point-down"
            className="dbi-filterfixed-header__show-arrow"
          />
        </div>
      </div>
    </div>
  );
};

export default StickyHeader;
